// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1oa75","rightAdornment":"Header_rightAdornment__ThSXZ"};